<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();
</script>

<template>
  <section class="h5-page">
    <header class="h5-hero">
      <div class="h5-hero__eyebrow">YHM STORE NETWORK</div>
      <h1>怡呵美门店资料上报</h1>
      <p>仅供怡呵美正式代理商使用。准备好资料后，按清单完成上报。</p>
    </header>
    <div class="h5-content">
      <div class="process-card" aria-label="门店申报流程">
        <div class="process-item"><div class="process-index">1</div><div><strong>门店上报</strong><span>填写门店信息并上传所需资料。</span></div></div>
        <div class="process-item"><div class="process-index">2</div><div><strong>平台审核</strong><span>工作人员核对资料；需要补充时会说明原因。</span></div></div>
        <div class="process-item"><div class="process-index">3</div><div><strong>运营对接</strong><span>审核通过后联系运营老师或小助理。</span></div></div>
      </div>
      <div class="required-checklist">请提前准备：门店定位截图、门头照片、店内环境、营业执照、法人身份证正反面及结算资料。</div>
    </div>
    <footer class="bottom-actions bottom-actions--home">
      <van-button type="primary" block size="large" @click="router.push('/shops/new')">开始门店上报</van-button>
      <van-button plain type="primary" block size="large" @click="router.push('/shops')">查看我的门店</van-button>
    </footer>
  </section>
</template>
